import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { LiveAnalyticsProvider } from "@/context/LiveAnalyticsContext";
import { LiveNotificationCenter } from "@/components/LiveNotificationCenter";
import AuthCallback from "@/pages/AuthCallback";
import Auth from "@/pages/Auth";
import ResetPassword from "@/pages/ResetPassword";
import Browse from "@/pages/Browse";
import MyListPage from "@/pages/MyListPage";
import Admin from "@/pages/Admin";
import TitleDetail from "@/pages/TitleDetail";
import PersonDetail from "@/pages/PersonDetail";
import Legal from "@/pages/Legal";
import RevistaList from "@/pages/RevistaList";
import ArticleDetail from "@/pages/ArticleDetail";
import ArticleEditor from "@/pages/ArticleEditor";
import Festivals from "@/pages/Festivals";
import { CookieBanner } from "@/components/CookieBanner";

function Protected({ children, adminOnly, roles }) {
  const { user, checking } = useAuth();
  if (checking || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="w-10 h-10 border-2 border-[#E11D48] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/auth" element={<Auth />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<Browse />} />
      <Route path="/titulo/:slug" element={<TitleDetail />} />
      <Route path="/persona/:id" element={<PersonDetail />} />
      <Route path="/actriz/:id" element={<PersonDetail />} />
      <Route path="/actor/:id" element={<PersonDetail />} />
      <Route path="/director/:id" element={<PersonDetail />} />
      <Route path="/legal/:page" element={<Legal />} />
      <Route path="/revista" element={<RevistaList />} />
      <Route path="/festivales" element={<Festivals />} />
      <Route path="/revista/:slug" element={<ArticleDetail />} />
      <Route path="/revista-editor" element={<Protected roles={["admin", "editor"]}><ArticleEditor /></Protected>} />
      <Route path="/mi-lista" element={<Protected><MyListPage /></Protected>} />
      <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LanguageProvider>
          <ThemeProvider>
            <BrowserRouter>
              <LiveAnalyticsProvider>
                <Toaster theme="dark" position="top-center" richColors />
                <LiveNotificationCenter />
                <AppRoutes />
                <CookieBanner />
              </LiveAnalyticsProvider>
            </BrowserRouter>
          </ThemeProvider>
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}
